import { useContext, useEffect } from 'react';
import { Box, Heading, Icon, Paragraph, TextButton } from '@zillow/constellation-10';
import { IconRateUnhappyFilled } from '@zillow/constellation-icons';
import { useTermSet } from '../../../IdvContext';
import { TermSet } from '../../../../../models';
import { RENTER_CANNOT_IDV_HELP_URL } from '../../../constants/urls';
import { WizardStepId } from '../../../wizard/wizardTypes';
import { WizardContext } from '../../../wizard/WizardContext';

function LandlordContent() {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Icon size="lg" css={{ color: 'icon.subtle' }}>
        <IconRateUnhappyFilled />
      </Icon>
      <Heading level={2} textStyle="heading-sm">
        Your identity couldn’t be verified
      </Heading>
      <Paragraph>
        We couldn’t verify your identity with the information provided. Until you’re verified, you won’t be able to
        access your applicant’s information, including credit check and background report.
      </Paragraph>
      <Paragraph>
        You can try again to get verified. When you enter your information, check that everything is correct, including
        your legal name, address, phone number, and Social Security number (if provided).
      </Paragraph>
    </Box>
  );
}

function RenterContent() {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default', alignItems: 'flex-start' }}>
      <Icon size="lg" css={{ color: 'icon.subtle' }}>
        <IconRateUnhappyFilled />
      </Icon>
      <Heading level={2} textStyle="heading-sm">
        Couldn’t verify your identity
      </Heading>
      <Paragraph>
        You can submit your identity verification again. Check that all information is correct, including your legal
        name, address, and Social Security number.
      </Paragraph>
      <TextButton asChild>
        <a href={RENTER_CANNOT_IDV_HELP_URL} target="_blank" rel="noopener noreferrer">
          Learn more
        </a>
      </TextButton>
    </Box>
  );
}

export default function ErrorUserNotFoundStep() {
  const { setOnNext, goToStep } = useContext(WizardContext);
  const termSet = useTermSet();

  useEffect(() => {
    setOnNext(() => () => goToStep(WizardStepId.PersonalInfo));
    return () => setOnNext(null);
  }, [goToStep, setOnNext]);

  return termSet === TermSet.LandlordScreening ? <LandlordContent /> : <RenterContent />;
}
